import { render } from "./ComplainingPage.vue?vue&type=template&id=4dbe6226&scoped=true"
import script from "./ComplainingPage.vue?vue&type=script&lang=js"
export * from "./ComplainingPage.vue?vue&type=script&lang=js"

import "./ComplainingPage.vue?vue&type=style&index=0&id=4dbe6226&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbe6226"]])

export default __exports__